module.exports = __webpack_public_path__ + "static/img/notice.f4d28ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/notice.svg
// module id = tb3b
// module chunks = 16